import ProductCategoryProvider from "@/modules/delivery/providers/ProductCategoryProvider";


export default {
    state: {
        categories: [],
    },
    getters: {
        categories(state) {
            return state.categories
        },
        getCategories(state) {
            return state.categories
        },
        getCategoryNameById(state){
            return (id) => {
                let category = state.categories.find(category => category.id === id)
                return category ? category.name : ''
            }
        }
    },
    actions:{
        async fetchCategories({commit}) {
            let r = await ProductCategoryProvider.fetchProductCategoryActive()
            commit("categories", r.data.fetchProductCategoryActive)
            return r.data.fetchProductCategoryActive
        },
    },
    mutations: {
        categories(state, categories) {
            state.categories = categories
        }
    }
}
